module.exports = __webpack_public_path__ + "static/media/clock.fa03b2f8.svg";